import { render, staticRenderFns } from "./ViAdmissionDashboard.vue?vue&type=template&id=cbb4fa38"
import script from "./ViAdmissionDashboard.vue?vue&type=script&lang=js"
export * from "./ViAdmissionDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports